var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.message && _vm.message.length > 0)?_c('div',{staticClass:"alert",on:{"click":function($event){return _vm.close()}}},[_c('p',{staticClass:"label",domProps:{"innerHTML":_vm._s(_vm.message)}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }